import { useState, useEffect } from 'react';

const navItems = [
  { href: '#hero', label: '首页' },
  { href: '#faq', label: '常见问题' },
  { href: '#contact', label: '投稿爆料' },
  { href: '#carousel', label: '焦点专题' },
  { href: '#updates', label: '最新动态' },
  { href: '#topics', label: '热门话题' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl md:text-3xl text-primary-500">
              91吃瓜
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-foreground-800' : 'text-white'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 bg-background-50 rounded-b-2xl border-b border-background-200/70">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="block px-6 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 text-sm font-medium transition-colors duration-200 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}